<template>
    <div id="app">
        <Nav />
        <Home />
        <!-- <vue-aos animation-class="fadeIn animated"> -->
            <About />
        <!-- </vue-aos> -->
        <Services />
        <Contact />
        <Footer />
    </div>
    <!--end.app-->
</template>

<script>
import Nav from "@/components/Nav";
import Home from "@/views/Home";
import About from "@/views/About";
import Services from "@/views/Services";
import Contact from "@/views/Contact";
import Footer from "@/views/Footer";
// import VueAos from 'vue-aos'

export default {
    components: {
        // VueAos,
        Nav,
        Home,
        About,
        Services,
        Contact,
        Footer
    },
    data() {
        return {
            //
        };
    },
    methods: {
        scrollFunction() {
            scroll(function() {
                if (
                    `${window}. scrollTop() + ${window}. height() > ${document}. height() - 100`
                ) {
                    alert("near bottom!");
                }
            });
        }
    },
    mounted() {
        // page load calls
        //////////////////
        this.scrollFunction();

        //our programatic media query
        //////////
        if (window.innerWidth <= 768) {
            this.isMobile = true;
        }

        if (window.innerHeight > 100) {
            // console.log("window viewport is greater than 100px");
        } else {
            alert("window viewport is lesser than 100px");
        }
    }
};
</script>

<style lang="scss">
@import "scss/style";
</style>
